import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  to, 
  href, 
  onClick, 
  variant = 'primary', 
  // size = 'md',
  className = '',
  ...props 
}) => {
  const baseStyles = "font-medium rounded transition-colors ";
  
  const variants = {
    primary: "bg-yellow-400 hover:bg-yellow-500 text-black py-2 px-3 text-sm sm:px-4 sm:text-base md:py-3 md:px-6 ",
    secondary: "bg-black dark:bg-white hover:bg-gray-950 dark:hover:bg-gray-300 text-white  dark:text-black py-2 px-3 text-sm sm:px-4 sm:text-base md:py-3 md:px-6",
    outline: "bg-transparent border-2 border-black text-black hover:bg-black hover:text-white py-2 px-3 text-sm sm:px-4 sm:text-base md:py-3 md:px-6",
    ghost: "text-black bg-gray-100 py-2 px-3 text-sm sm:px-4 sm:text-base md:py-3 md:px-6",
    outlinePrimary: "bg-transparent border sm:border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-normal py-2 px-3 text-sm sm:px-4 sm:text-base md:py-3 md:px-6",
    outlineSecondary: "bg-transparent border sm:border-2 border-black text-black hover:bg-black hover:text-white font-normal py-2 px-3 text-sm sm:px-4 sm:text-base md:py-3 md:px-6",
  };
  
  // const sizes = {
  //   sm: "py-2 px-3 text-sm",
  //   md: "py-2 px-4",
  //   lg: "py-3 px-6 text-lg",
  // };
  
  const buttonStyles = `${baseStyles} ${variants[variant]}  ${className}`;
  
  if (to) {
    return (
      <Link to={to} className={buttonStyles} {...props}>
        {children}
      </Link>
    );
  }
  
  if (href) {
    return (
      <a href={href} className={buttonStyles} {...props}>
        {children}
      </a>
    );
  }
  
  return (
    <button className={buttonStyles} onClick={onClick} {...props}>
      {children}
    </button>
  );
};

export default Button;